<template>
  <vue-scroll class="page-dashboard">
    <rabbey-top-menu />
  </vue-scroll>
</template>
<script>
export default {
  name: "OurCompany"
};
</script>

<style></style>
